module.exports = __webpack_public_path__ + "img/antes_despues_113.cd1a49f2.png";